import { FC } from 'react';

const SafityInformation: FC = () => {
  return (
    <section className="bg-white py-10 px-5">
      <p className="font-semibold text-lg max-w-[1090px] mx-auto text-wcw-grey">
        This website is not intended to provide diagnosis, treatment, or medical
        advice. Products, services, information and other content provided on
        this website are provided for informational purposes only. Information
        on this website should not be considered as a substitute for advice from
        a healthcare professional. Consult with a physician or other healthcare
        professional regarding any medical or health-related diagnosis or
        treatment options.
      </p>
    </section>
  );
};

export { SafityInformation };
